// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"164":"8ee52334","453":"d47fa7c3","749":"8851622b"}[chunkId] + ".chunk.js");